var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3832 4.00076C21.2035 3.17068 21.2035 1.82263 20.3832 0.992554C19.5629 0.162476 18.2307 0.162476 17.4104 0.992554L10.5 7.99177L3.58316 0.999194C2.76285 0.169116 1.43066 0.169116 0.610352 0.999194C-0.209961 1.82927 -0.209961 3.17732 0.610352 4.0074L7.52723 11L0.616914 17.9992C-0.203398 18.8293 -0.203398 20.1773 0.616914 21.0074C1.43723 21.8375 2.76941 21.8375 3.58973 21.0074L10.5 14.0082L17.4169 21.0008C18.2372 21.8308 19.5694 21.8308 20.3897 21.0008C21.21 20.1707 21.21 18.8226 20.3897 17.9926L13.4729 11L20.3832 4.00076Z",
    fill: "url(#paint0_linear_164_1155)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_164_1155",
    x1: -0.0048828,
    y1: 11.7086,
    x2: 21.005,
    y2: 11.7086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.12d8d0734900ea4002ce90cfefe4a674.svg";
export { ForwardRef as ReactComponent };